import React, { FC } from 'react';
import { Box, Button, Link, Typography } from '@mui/material';

import useStyles from './styles';

/**
 * This file doesn't use the translation engine because it
 * is expected to be changing frequently. We'll implement translation
 * when the product team adds support for non-English customers
 */
const Teams: FC = () => {
  const classes = useStyles;

  return (
    <Box textAlign="center" maxWidth={350}>
      <Typography gutterBottom variant="h2">
        Upgrade to Enterprise
      </Typography>
      <Typography sx={classes.customType1}>
        Everything you need to scale across multiple departments or your entire workforce.
      </Typography>
      <Box paddingTop={6}>
        <Typography variant="subtitle1" color="textSecondary">
          Everything in Teams, plus:
        </Typography>
        <Typography variant="subtitle1">Dedicated Client Success Team</Typography>
        <Typography variant="subtitle1">Tailored implementation and training</Typography>
        <Typography variant="subtitle1">24/7 support with short response time</Typography>
        <Typography variant="subtitle1">SSO and SCIM provisioning</Typography>
        <Typography variant="subtitle1">Security and compliance SLAs</Typography>
        <Link
          color="primary"
          display="block"
          target="_blank"
          variant="subtitle1"
          href="https://everyonesocial.com/pricing/#cm-details"
          underline="hover"
        >
          See plan details
        </Link>
      </Box>
      <Box paddingTop={3}>
        <Button
          size="large"
          target="_blank"
          href="https://everyonesocial.com/demo/"
          variant="contained"
          color="primary"
        >
          Contact Sales
        </Button>
      </Box>
    </Box>
  );
};

export default Teams;
